import { action } from 'typesafe-actions';

import { TravelHotelSearchResponse } from 'models/hotelLocation';

export const HOTEL_LOCATIONS_REQUEST = 'HOTEL_LOCATIONS_REQUEST';
export const HOTEL_LOCATIONS_SUCCESSFUL = 'HOTEL_LOCATIONS_SUCCESSFUL';
export const HOTEL_LOCATIONS_FAILURE = 'HOTEL_LOCATIONS_FAILURE';

export const hotelLocationsRequest = () => action(HOTEL_LOCATIONS_REQUEST);

export const hotelLocationsSuccessful = (response: TravelHotelSearchResponse) =>
  action(HOTEL_LOCATIONS_SUCCESSFUL, response);

export const hotelLocationsError = (error: string) => action(HOTEL_LOCATIONS_FAILURE, error);
